import {
  Button,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Input,
  Option,
  Select,
  Textarea,
  Typography
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import Dict from "../../helper/dict";
import {getConsultationAgentBranchFee} from "../../services/agent_branch_fee/agent_branch_fee";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {Toaster} from "../../helper/Toaster";
import jalaali from "jalaali-js";
import {TimeClock} from "../system/timeClock/timeClock";
import {toast} from "react-toastify";

export function ReservationBranchAndTimeForm({
                                               event,
                                               agent_id,
                                               branch_id,
                                               open,
                                               setOpen,
                                               onSave,
                                               currentAgentId,
                                               currentBranchId,
                                               currentMinute,
                                               scheduleStartTime,
                                               scheduleEndTime,
                                             }) {

  const handleOpen = () => setOpen(!open);

  const [agentId, setAgentId] = useState(currentAgentId);
  const [title, setTitle] = useState("");
  const [userStartTime, setUserStartTime] = useState(scheduleStartTime || "00:00");
  const [minute, setMinute] = useState(15);
  const [topic, setTopic] = useState("");
  const [challenge, setChallenge] = useState("");

  const [branchId, setBranchId] = useState(branch_id);

  const [branchFee, setBranchFee] = useState(0);
  const [branchVatPercentage, setBranchVatPercentage] = useState(0);
  const [consultationPrice, setConsultationPrice] = useState(0);

  const [dataLoaded, setDataLoaded] = useState(false);

  const [formattedDate, setFormattedDate] = useState("");

  useEffect(() => {
    const new_date = event.jalaliDate.split("-")[0] + "/" + event.jalaliDate.split("-")[1] + "/" + event.jalaliDate.split("-")[2];
    setFormattedDate(new_date)
  }, [event.jalaliDate]);

  useEffect(() => {
    setBranchId(currentBranchId);
    setMinute(currentMinute)
    setAgentId(currentAgentId);
    if (!currentBranchId) {
      setDataLoaded(true);
    }
  }, []);

  useEffect(() => {
    setDataLoaded(true);
  }, [branchId])


  useEffect(() => {
    setAgentId(currentAgentId);
  }, [currentAgentId]);


  useEffect(() => {
    async function getData(branchId, agentId) {
      const result = await getConsultationAgentBranchFee(branchId, agentId);
      if (result.status === 200) {
        const {agent_branch_fee_and_vat} = result.data;
        setBranchFee(agent_branch_fee_and_vat?.price ?? 0);
        setBranchVatPercentage(agent_branch_fee_and_vat?.vat_percentage ?? 0);
      }
    }

    if (branchId && agentId) {
      getData(branchId, agentId);
    }
  }, [branchId, agentId])

  useEffect(() => {
    var price = parseInt(minute) * parseInt(branchFee)
    setConsultationPrice(price)
  }, [branchFee, minute]);

  const save = () => {
    const eventGorg = jalaali.toGregorian(parseInt(event.jalaliDate.split('-')[0]), parseInt(event.jalaliDate.split('-')[1]), parseInt(event.jalaliDate.split('-')[2]))
    if (Date.now() > Date.parse(`${eventGorg.gy}-${eventGorg.gm}-${eventGorg.gd} ${userStartTime}`)) {
      toast.error("امکان رزرو برای زمان‌های قبلی از اکنون ممکن نیست!")
      return
    }
    onSave(agentId, branchFee, branchVatPercentage, consultationPrice, branchId, userStartTime, minute, topic, challenge);
  };

  const persianDays = {
    '1': 'شنبه',
    '2': 'یکشنبه',
    '3': 'دوشنبه',
    '4': 'سه‌شنبه',
    '5': 'چهارشنبه',
    '6': 'پنجشنبه',
    '7': 'جمعه'
  };

  const durationOptions = [5, 10, 15, 20, 25, 30, 45, 60];
  const cleanTime = (time) => (time || "00:00").replace(/:00$/, "");

  if (agentId && dataLoaded) {
    return (
      <>
        <DialogHeader className="border-b border-gray-200 bg-gray-900 px-5 py-4">
          <div className="flex w-full flex-col gap-3 text-right">
            <div className="flex flex-col gap-1">
              <Typography className="text-lg font-bold text-white md:text-xl">
              تعیین وقت مشاوره
            </Typography>
              <Typography className="text-sm font-normal text-gray-300">
                {`${persianDays[event.week_day_id]} - ${persianNumberFormat(formattedDate)}`}
            </Typography>
            </div>
            <div className="flex flex-col gap-1 rounded-md border border-gray-700 bg-white/10 px-4 py-3 sm:flex-row sm:items-center sm:justify-between">
              <Typography className="text-sm font-medium text-white">
                تایم آزاد مشاور
              </Typography>
              <Typography className="text-sm font-semibold text-white">
                {persianNumberFormat(`${cleanTime(scheduleStartTime)} تا ${cleanTime(scheduleEndTime)}`)}
            </Typography>
            </div>
          </div>
        </DialogHeader>
        <DialogBody className="max-h-[70vh] overflow-y-auto px-5 py-5">
          <div className="mb-5 rounded-md border border-blue-gray-100 bg-blue-gray-50 px-4 py-3">
            <Typography color="blue-gray" className="text-sm leading-6">
              لطفا توجه نمائید: اولین زمان دریافت مشاوره از 5 دقیقه بعد از رزرو امکان پذیر است.
            </Typography>
          </div>

          <div className="grid gap-5 md:grid-cols-[240px_minmax(0,1fr)]">
            <div className="flex justify-center rounded-md border border-gray-200 px-4 py-4">
              <TimeClock label={Dict("consultation_start_time")} value={userStartTime || "00:00"}
                         onChange={setUserStartTime}/>
            </div>

            <div className="flex flex-col gap-5">
              <div className="rounded-md border border-gray-200 px-4 py-4">
                <Select variant="static" className="rtl" style={{label: {left: ""}}}
                        label={Dict('consultation_minute')}
                        value={minute}
                        onChange={(val) => setMinute(val)}>
                  {durationOptions.map((duration) => (
                    <Option key={duration} value={duration}>
                      {`${persianNumberFormat(duration)} دقیقه - ${persianNumberFormat(duration * branchFee, true)} ریال`}
                    </Option>
                  ))}
                </Select>
                <div className="mt-4 flex items-center justify-between border-t border-gray-100 pt-3">
                  <Typography className="text-sm text-gray-600">
                    {Dict('total_consultation_price')}
                  </Typography>
                  <Typography className="text-sm font-bold text-gray-900">
                    {`${persianNumberFormat(consultationPrice, true)} ریال`}
                  </Typography>
                </div>
              </div>

              <Input variant="standard"
                     label={Dict("consultation_topic")}
                     placeholder={Dict("consultation_topic")}
                     value={topic}
                     onChange={(e) => {
                       setTopic(e.target.value)
                     }}
              />

              <Textarea variant="standard"
                        label={Dict("challenge")}
                        value={challenge}
                        onChange={(e) => {
                          setChallenge(e.target.value)
                        }}
              />
            </div>
          </div>
        </DialogBody>
        <DialogFooter className="border-t border-gray-100 px-5 py-4">
          <div className="flex w-full flex-col-reverse gap-2 sm:flex-row sm:justify-end">
            <Button variant="text" color="gray" onClick={handleOpen}>
              <span>انصراف</span>
            </Button>
            <Button variant="gradient" color="gray" onClick={save} className="sm:ml-1">
              <span>ادامه</span>
            </Button>
          </div>
        </DialogFooter>
      </>
    );
  }
}
